<script setup>
import { onMounted, ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import PremiumPageHeader from "@/Components/PremiumPageHeader.vue";
import PremiumTabs from "@/Components/PremiumTabs.vue";
import Buttons from "@/Components/Buttons.vue";
import { Icon } from '@iconify/vue';
import { mdiPencil, mdiPlusCircle, mdiMagnify, mdiCircleMedium, mdiCircle, mdiCloudUploadOutline, mdiCloseCircle, mdiTrashCan, mdiStarOutline, mdiEye, mdiDownload, mdiInformationOutline, mdiChevronRight, mdiFilePdfBox, mdiFileExcel, mdiFileWord, mdiFilePowerpoint, mdiMusicBox, mdiNoteText, mdiPlayBox, mdiZipBox, mdiMinusBox, mdiArrowUpBold, mdiFile, mdiFolder, mdiNoteTextOutline } from "@mdi/js";
import VueSelect from "vue3-select-component";
import NotificationAlert from "@/Components/NotificationAlert.vue";
import { computed } from "vue";
//import WebViewer from "@/Components/WebViewer.vue";

const props = defineProps({
    courses: Array,
    origin_type: String,
    id_user: Number,
    classrooms: Array,
    canView: Boolean,
    canDownload: Boolean,
    canWrite: Boolean,
    canWriteAll: Boolean,
    canUpdate: Boolean,
    canDelete: Boolean,
    canReadSedes: Boolean,
    canWriteSedes: Boolean,
    apiSedes: Array,
    anioEscolar: String,
    course: Object,
    classroom: Object,
    back_link: String,
    isMaster: Boolean,
    isTutor: Boolean,
    isCoord: Boolean,
    origin_id_classroom: Number
});

const msg1 = ref('')
onMounted(() => {
    //console.log(msg)
    // msg1.value = msg
});

const backLink = ref(props.back_link ? '/#' + props.back_link : '')
const isModalActive = ref(false)
const selectedEvent = ref({})
const showDialog = ref(false)
const isModalDangerActive = ref(false);
const titleModal = ref('')
const isModalFullActive = ref(false);
const modalFullSrc = ref('');
const tab = ref(0)

const tabsMenu = computed(() => [
    { id: 0, label: 'Documentos', icon: 'tabler:folders', show: true },
    { id: 1, label: 'Documentos Libres', icon: 'tabler:folder-open', show: true }
]);

const onEventClick = (event, e) => {
    selectedEvent.value = event
    showDialog.value = true
    // Prevent navigating to narrower view (default vue-cal behavior).
    e.stopPropagation()
}

const rowID = ref(0);
const rowAction = ref('');
const initModal = (id = 0, action = 'create', data = []) => {
    rowAction.value = action
    rowID.value = id;
    if (action == 'update') {
        showDialog.value = false

        formEvent.id = data['id']
        formEvent.start = data['start_datetime']
        formEvent.end = data['end_datetime']
        formEvent.title = data['title']
        formEvent.contentFull = data['contentFull']
        formEvent.type_source = data['class']
        formEvent.id_source = data['id_source']

        console.log(data['start'] + ' - ' + data['end'])
    }
    if (action == 'delete' || action == 'eliminar') {
        titleModal.value = 'eliminar'
        showDialog.value = false
        isModalDangerActive.value = true
        formEvent.id = rowID.value
    } else {
        // create
        isModalActive.value = true
    }

}

const isConfirm = () => {

    if (massaction.value != '') {
        // Mass Action
        massAction(massaction.value)
    } else {
        // Event
        eventUpdateOrCreate(rowID.value, rowAction.value)
    }

    isModalActive.value = false
    cleanVal()
}

const isCancel = () => {
    isModalActive.value = false
    cleanVal()
}

const cleanVal = (cleanEditor = 1) => {

    rowID.value = 0;
    rowAction.value = ''

    formEvent.id = 0
    formEvent.start = ''
    formEvent.end = ''
    formEvent.title = ''
    formEvent.contentFull = ''
    formEvent.type_source = 'user_private'
    formEvent.id_source = 0

    selectRows.value = []
    allCheckBox.value = false
    countChecked.value = 0
    massaction.value = ''
    id_select1.value = 0
    id_select2.value = 0
    id_select3.value = 0
    id_select4.value = 0

    // Tarea
    /*
    if (cleanEditor) {// <-- No borrar si cierro el editor en nueva edición
        formTarea.label = ''
        formTarea.description = ''
        formTarea.end_date = null
        formTarea.status = 0
        tareaEditor.value.setContents('')// <-- Limpiar contenido de texto enriquecido
    } */
}

/**
 * Crear eventos
 */
const formEvent = useForm({
    id: 0,
    start: '',
    end: '',
    title: '',
    contentFull: '',
    type_source: 'user_private',
    id_source: 0,

    module_origin: 'documents'
})
const arrayEvent = ref([])
const errorEvent = ref('')
const prefijoRuta = 'file'
const eventUpdateOrCreate = (id = 0, action = '') => {
    let prefijo = prefijoRuta
    let ruta = prefijo + '-registrar';
    if (id > 0) {
        ruta = prefijo + '-actualizar';

        if (action == 'eliminar') {
            ruta = prefijo + '-eliminar';

            axios.post(route(ruta), formEvent).then((response) => {
                if (response.data.error) {
                    //showAlert(response.data.message, 'danger', 5)
                    //errorMessage.value = response.data.message
                    errorEvent.value = response.data.error;
                } else if (response.data.success) {
                    //showAlert(response.data.message, 'success', 2)
                    //successMessage.value == response.data.message

                    //Inertia.reload({ only: ['events', 'eventsnow'] })
                    //onToggle()
                    listarDocuments()
                    console.log('Evento eliminado')
                }

            }).catch((error) => {
                console.log(error);
            });

            return;
        }
    }

    // Registrar o actualizar
    if (formEvent.type_source == 'temario') {
        if (!formEvent.title || !formEvent.start || !formEvent.end || !formEvent.id_source) {
            errorEvent.value = 'Debe ingresar un tema, rango de fechas y un curso'
        } else {
            errorEvent.value = ''
        }
    } else {
        if (!formEvent.title || !formEvent.start || !formEvent.end) {
            errorEvent.value = 'Debe ingresar un título y rango de fechas'
        } else {
            errorEvent.value = ''
        }
    }

    if (!errorEvent.value) {
        axios.post(route(ruta), formEvent).then((response) => {
            if (response.data.error) {
                //showAlert(response.data.message, 'danger', 5)
                //errorMessage.value = response.data.message
                errorEvent.value = response.data.error;
            } else if (response.data.success) {
                //showAlert(response.data.message, 'success', 2)
                //successMessage.value == response.data.message

                //Inertia.reload({ only: ['events', 'eventsnow'] })
                //onToggle()
                console.log((id > 0 ? 'Evento actualizado' : 'Evento creado'))
            }

        }).catch((error) => {
            console.log(error);
        });
    }

}

const id_source = ref(0)
const type_source = ref('')


/**
 * Listar documents
 */
const anioSearch = ref(props.anioEscolar)
const type = ref(props.origin_type)
const id_course = ref(0)
const ref_course = ref('')
const id_classroom = ref(props.origin_id_classroom ? props.origin_id_classroom : 0)
const sedes = ref([])
const arrayFiles = ref([])
const listarDocuments = () => {
    let url = '/file/documents/list' + '?type=' + type.value + '&id_course=' + id_course.value + '&id_classroom=' + id_classroom.value + '&anioSearch=' + anioSearch.value; // <-- si no es el año lectivo actual tomar otra aula en el controller
    loading.value = true;
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayFiles.value = respuesta.datalist;
        if (respuesta.error) {
            //showAlert(respuesta.message, 'danger', 16)
        }
        console.log(arrayFiles.value);
    }).catch(function (error) {
        console.log(error);
    });
    loading.value = false;
}

const selectedFiles = ref([])
const allowMultiple = ref(true)
const replace_file = ref(false)
const fileSize = ref(0)
const filepreviewlist = ref('')
const loaderUpload = ref(false)
const successUpload = ref(false)
const loaderUploads = ref([])
const successUploads = ref([])
props.apiSedes.forEach((loader, index) => {
    loaderUploads.value[index] = false
})
props.apiSedes.forEach((loader, index) => {
    successUploads.value[index] = false
})
const handleFileSelect = (event) => {

    selectedFiles.value = event.target.files;
    filepreviewlist.value = '<ol>';
    for (let i = 0; i < selectedFiles.value.length; i++) {
        filepreviewlist.value += '<li style="font-size: 12px">'
        filepreviewlist.value += selectedFiles.value[i].name;
        filepreviewlist.value += '</li>'
    }
    filepreviewlist.value += '</ol>';
    // You can now process the selected files, e.g., display their names or prepare for upload

    // Cada vez que se selecciona archivos se reseteará el color
    successUpload.value = false
    props.apiSedes.forEach((loader, index) => {
        successUploads.value[index] = false
    })

    //fileSubida.value = this.$refs.fileSubida.files[0];
    /* let file = null;
    if (type == 'file_document_student') {
        file = fileDocument.value.files[0];
    }

    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    } */

}

// Cambiar ruta para /api/upload -> Para cada sede
const uploadFiles = async (ruta = '/file/uploads', sede_externa = 0, token = '', index_sede = null, user = '') => {

    if (!selectedFiles.value) {
        console.warn("No files selected for upload.");
        return;
    }
    //console.log(selectedFiles.value)

    const formData = new FormData();
    for (let i = 0; i < selectedFiles.value.length; i++) {
        formData.append('files[]', selectedFiles.value[i]); // 'files' is the field name on your server
    }
    //formData.append('files', selectedFiles.value)
    formData.append('type', type.value)
    formData.append('id_course', id_course.value)
    formData.append('ref_course', ref_course.value)
    formData.append('id_classroom', id_classroom.value)
    formData.append('replace_file', replace_file.value)
    formData.append('sede_externa', sede_externa)
    formData.append('user', user)

    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload Progress: ${percentCompleted}%`);
            // Update a progress bar in your UI if needed
        }
    }

    if (sede_externa == 1) {
        ruta = ruta + '/api/file/uploads'
        config = {
            headers: {
                // -LRR 'Authorization: Token token= "' . $ecommerce_token . '"',
                'Authorization': 'Bearer ' + token + '',
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                console.log(`Upload Progress: ${percentCompleted}%`);
                // Update a progress bar in your UI if needed
            }
        }

        loaderUploads.value[index_sede] = true
    } else {
        loaderUpload.value = true
    }

    //console.log(replace_file.value)
    // Iniciar la api ruta aquí /api/upload -> Para cada sede <-- A futuro cambiar a cada sede

    try {


        /* const response = await axios.post(ruta, formData, {
            headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            console.log(`Upload Progress: ${percentCompleted}%`);
            // Update a progress bar in your UI if needed
        }
        });
        console.log('Upload successful:', response.data);
        // Handle successful upload (e.g., clear selected files, display success message) */

        await axios.post(ruta, formData, config)
            .then(response => {
                if (response.data.error) {
                    showAlert(response.data.message, 'danger', 10)
                } else if (response.data.success) {
                    showAlert(response.data.message, 'success', 5)
                    listarDocuments()
                    //cleanInputFile()
                    if (sede_externa == 1) {
                        successUploads.value[index_sede] = true
                    } else {
                        successUpload.value = true
                    }

                }
                console.log(response.data)
            })
            .catch(error => {
                console.log(error)
            })


    } catch (error) {
        console.error('Upload failed:', error);
        // Handle upload error (e.g., display error message)
    }
    if (sede_externa == 1) {
        loaderUploads.value[index_sede] = false
    } else {
        loaderUpload.value = false
    }

}

const handleSelectCourse = (event) => {
    //const selectedId = parseInt(event.target.value) // event.target.value will be string, but need number
    const selectedId = parseInt(event)

    // and actually, it only took adding one extra line to reference the original object
    if (selectedId > 0) {
        const selectedCourse = props.courses.find(option => option.value == selectedId);
        console.log('Curso seleccionado: ' + selectedCourse.ref + ' Curso ID: ' + selectedCourse.value)
    }

}

const handleSelectClassroom = (event) => {
    //const selectedId = parseInt(event.target.value) // event.target.value will be string, but need number
    const selectedId = parseInt(event)

    // and actually, it only took adding one extra line to reference the original object
    if (selectedId > 0) {
        const selectedClassroom = props.classrooms.find(option => option.value == selectedId);
        console.log('Aula seleccionada: ' + selectedClassroom.ref + ' Aula ID: ' + selectedClassroom.value)
    }

}

/**
 * Section Alert
 */

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message, color, time = 1) => {

    messageAlert.value = message
    colorAlert.value = color

    isAlertActive.value = true

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

// Formatos de fecha y tiempo
const formatDate = (datesource, format = 'day') => {
    //var now = new Date().toLocaleDateString()
    if (datesource) {
        var date = new Date(datesource + 'T00:00:00')// <-- Con let no funcionaba <-- Agregar la hora para que no reste un día por la zona horaria del navegador
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = ''
        if (format == 'day') {
            result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        } else if ((format == 'Y')) {
            result = date.getFullYear()
        }

        return result
    }

}

//console.log(props.object)
const formatDateTime = (datetime) => {
    if (datetime) {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + ' ' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

}

// Cargar vista modal Full para vista previa
const srcParamOnlyRead = ref('')
const showVistaPrevia = (ruta = '', option = '') => {
    isModalFullActive.value = true
    //modalFullSrc.value = ruta + (props.canWrite ? '' : '#toolbar=0') // <-- ocultar toolbar y a futuro ocultar context menu :oncontextmenu
    modalFullSrc.value = ruta

    if (option == 'onlyread') {
        srcParamOnlyRead.value = '#toolbar=0' // <-- ocultar toolbar y a futuro ocultar context menu :oncontextmenu
        //let buttondownload = document.getElementById('#downloads');
        //if (buttondownload) {
        //console.log('hide download preview')
        //buttondownload.hide();
        //}
    } else {
        srcParamOnlyRead.value = ''
    }
}

const showAyuda = ref([
    { 'documents': false },
    { 'silabo': false }
])

/**
 * Check rows Acciones masivas
 */
const loading = ref(false)
const selectRows = ref([])
const allCheckBox = ref(false)
const countChecked = ref(0)
const massaction = ref('')
const id_select1 = ref(0)
const id_select2 = ref(0)
const id_select3 = ref(0)
const id_select4 = ref(0)

const massiveFieldValue = ref('')
const massiveFieldValue2 = ref('')
const massiveFieldValue3 = ref('')

const massAction = async (action) => {
    //let ruta = mainStore.ruta + '-massaction'
    //let url = route(ruta);
    let ruta = '/file/massaction';
    var arrayitemschecks = []

    for (var i = 0; i < arrayFiles.value.length; i++) {
        if (selectRows.value[i + 1] == true) {
            //arrayitemschecks[i] = arrayFiles.value[i].id
            arrayitemschecks[i] = arrayFiles.value[i].id


        }
    }

    // Eliminar nulos -> Compmatibilidad de uso de Axios en lugar de Inertia
    var arrayitems = arrayitemschecks.filter(function (el) {
        return el != null;
    });

    // FIX 240312 <-- Inertia post and put to Axios
    let formMassAction = {
        'action': action,
        'cr': arrayitems,// checkedRows <-- Minimizar URI
        'origin_type': 'documents_resources',
        'id_select1': id_select1.value,
        'id_select2': id_select2.value,
        'id_select3': id_select3.value,
        'id_select4': id_select4.value,
        'field_value': massiveFieldValue.value,
        'field_value2': massiveFieldValue2.value,
        'field_value3': massiveFieldValue3.value
    };

    loading.value = true;
    await axios.put(ruta, formMassAction).then((response) => {
        let respuesta = response.data;
        if (respuesta.success) {
            if (respuesta.warning) {
                showAlert(respuesta.message, 'warning', 16)
            } else {
                showAlert(respuesta.message, 'success', 8)
            }
            listarDocuments()
            //cleanMassAction()
            cleanVal()
            //emit('reload') // SI existe reload emitir una acción

        } else {
            showAlert(respuesta.message, 'danger', 64)
        }
        console.log('Registros masivos cambiados en ' + action); // Acciones masivas
        //console.log(respuesta);
    }).catch((error) => {
        console.log(error);
        console.log('Registros masivos no cambiados');
    });
    loading.value = false;

    cleanVal()
    //cleanMassAction()
    //console.log(arrayitems)
}

const countCheckedSingle = () => {
    countChecked.value = 0// <-- Reiniciar contador
    for (var i = 0; i < selectRows.value.length; i++) {

        if (selectRows.value[i + 1] == true) {
            countChecked.value++
        }
    }
}

const changeAllCheckBox = () => {
    //console.log(itemsPaginated.value.length)
    countChecked.value = 0// <-- Reiniciar contador
    for (var i = 0; i < arrayFiles.value.length; i++) {
        selectRows.value[i + 1] = !selectRows.value[i + 1]
        if (selectRows.value[i + 1] == true) {
            countChecked.value++
        }
    }
}

// State variables for Documentos Libres
const freeFolders = ref([]);
const freeFiles = ref([]);
const freeBreadcrumbs = ref([]);
const currentFreeFolderId = ref(null);

const isFolderModalActive = ref(false);
const isRenameFolderModalActive = ref(false);
const isRenameFileModalActive = ref(false);
const isFileUploadModalActive = ref(false);

const selectedFreeItem = ref(null);

const freeFolderForm = ref({
    name: '',
    isPublic: false
});

const freeFileForm = ref({
    name: ''
});

const uploadFreeFilesList = ref([]);
const uploadFreeFileIsPublic = ref(false);
const freeFilePreviewList = ref('');

const switchTab = (tabVal) => {
    tab.value = tabVal;
    if (tabVal === 1) {
        fetchFreeFolder(null);
    }
};

const fetchFreeFolder = (folderId = null) => {
    loading.value = true;
    let url = `/free-folders/list`;
    if (folderId !== null && folderId !== undefined) {
        url += `/${folderId}`;
    }
    axios.get(url).then((response) => {
        if (response.data.success) {
            freeFolders.value = response.data.folders;
            freeFiles.value = response.data.files;
            freeBreadcrumbs.value = response.data.breadcrumbs;
            currentFreeFolderId.value = response.data.currentFolder ? response.data.currentFolder.id : null;
        }
        loading.value = false;
    }).catch((error) => {
        console.error(error);
        loading.value = false;
    });
};

const openFolderModal = () => {
    freeFolderForm.value.name = '';
    freeFolderForm.value.isPublic = false;
    isFolderModalActive.value = true;
};

const createFreeFolder = () => {
    if (!freeFolderForm.value.name) return;
    axios.post('/free-folders/create', {
        name: freeFolderForm.value.name,
        parent_id: currentFreeFolderId.value,
        isPublic: freeFolderForm.value.isPublic
    }).then((response) => {
        isFolderModalActive.value = false;
        fetchFreeFolder(currentFreeFolderId.value);
        messageAlert.value = response.data.message;
        colorAlert.value = 'success';
        isAlertActive.value = true;
    }).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.message) {
            messageAlert.value = error.response.data.message;
            colorAlert.value = 'danger';
            isAlertActive.value = true;
        }
    });
};

const openRenameFolderModal = (folder) => {
    selectedFreeItem.value = folder;
    freeFolderForm.value.name = folder.name;
    isRenameFolderModalActive.value = true;
};

const submitRenameFolder = () => {
    if (!freeFolderForm.value.name || !selectedFreeItem.value) return;
    axios.put(`/free-folders/${selectedFreeItem.value.id}/rename`, {
        name: freeFolderForm.value.name
    }).then((response) => {
        isRenameFolderModalActive.value = false;
        fetchFreeFolder(currentFreeFolderId.value);
        messageAlert.value = response.data.message;
        colorAlert.value = 'success';
        isAlertActive.value = true;
    }).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.message) {
            messageAlert.value = error.response.data.message;
            colorAlert.value = 'danger';
            isAlertActive.value = true;
        }
    });
};

const deleteFreeFolder = (folder) => {
    if (confirm(`¿Está seguro de eliminar la carpeta "${folder.name}" y todo su contenido?`)) {
        loading.value = true;
        axios.delete(`/free-folders/${folder.id}`).then((response) => {
            fetchFreeFolder(currentFreeFolderId.value);
            messageAlert.value = response.data.message;
            colorAlert.value = 'success';
            isAlertActive.value = true;
        }).catch((error) => {
            console.error(error);
            loading.value = false;
        });
    }
};

const openFileUploadModal = () => {
    uploadFreeFilesList.value = [];
    uploadFreeFileIsPublic.value = false;
    freeFilePreviewList.value = '';
    isFileUploadModalActive.value = true;
};

const handleFreeFileSelect = (event) => {
    uploadFreeFilesList.value = event.target.files;
    freeFilePreviewList.value = '<ol class="list-decimal pl-4">';
    for (let i = 0; i < uploadFreeFilesList.value.length; i++) {
        freeFilePreviewList.value += `<li class="text-xs text-gray-600">${uploadFreeFilesList.value[i].name}</li>`;
    }
    freeFilePreviewList.value += '</ol>';
};

const uploadFreeFiles = () => {
    if (uploadFreeFilesList.value.length === 0) return;

    loading.value = true;
    const formData = new FormData();
    for (let i = 0; i < uploadFreeFilesList.value.length; i++) {
        formData.append('files[]', uploadFreeFilesList.value[i]);
    }
    formData.append('free_folder_id', currentFreeFolderId.value || '');
    if (uploadFreeFileIsPublic.value) {
        formData.append('isPublic', '1');
    }

    axios.post('/free-files/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((response) => {
        isFileUploadModalActive.value = false;
        fetchFreeFolder(currentFreeFolderId.value);
        messageAlert.value = response.data.message;
        colorAlert.value = 'success';
        isAlertActive.value = true;
    }).catch((error) => {
        console.error(error);
        loading.value = false;
    });
};

const openRenameFileModal = (file) => {
    selectedFreeItem.value = file;
    freeFileForm.value.name = file.name;
    isRenameFileModalActive.value = true;
};

const submitRenameFile = () => {
    if (!freeFileForm.value.name || !selectedFreeItem.value) return;
    axios.put(`/free-files/${selectedFreeItem.value.id}/rename`, {
        name: freeFileForm.value.name
    }).then((response) => {
        isRenameFileModalActive.value = false;
        fetchFreeFolder(currentFreeFolderId.value);
        messageAlert.value = response.data.message;
        colorAlert.value = 'success';
        isAlertActive.value = true;
    }).catch((error) => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.message) {
            messageAlert.value = error.response.data.message;
            colorAlert.value = 'danger';
            isAlertActive.value = true;
        }
    });
};

const deleteFreeFile = (file) => {
    if (confirm(`¿Está seguro de eliminar el archivo "${file.name}"?`)) {
        loading.value = true;
        axios.delete(`/free-files/${file.id}`).then((response) => {
            fetchFreeFolder(currentFreeFolderId.value);
            messageAlert.value = response.data.message;
            colorAlert.value = 'success';
            isAlertActive.value = true;
        }).catch((error) => {
            console.error(error);
            loading.value = false;
        });
    }
};

const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

const getFileIcon = (ext) => {
    const extension = (ext || '').toLowerCase();
    switch (extension) {
        case 'pdf': return mdiFilePdfBox;
        case 'xls':
        case 'xlsx': return mdiFileExcel;
        case 'doc':
        case 'docx': return mdiFileWord;
        case 'ppt':
        case 'pptx': return mdiFilePowerpoint;
        case 'mp3':
        case 'wav': return mdiMusicBox;
        case 'txt': return mdiNoteTextOutline;
        case 'mp4':
        case 'avi': return mdiPlayBox;
        case 'zip':
        case 'rar': return mdiZipBox;
        default: return mdiFile;
    }
};

const getFileIconColor = (ext) => {
    const extension = (ext || '').toLowerCase();
    switch (extension) {
        case 'pdf': return 'text-red-600';
        case 'xls':
        case 'xlsx': return 'text-green-600';
        case 'doc':
        case 'docx': return 'text-blue-600';
        case 'ppt':
        case 'pptx': return 'text-orange-700';
        case 'mp3':
        case 'wav': return 'text-cyan-600';
        case 'txt': return 'text-slate-700';
        case 'mp4':
        case 'avi': return 'text-rose-600';
        case 'zip':
        case 'rar': return 'text-indigo-700';
        default: return 'text-stone-600';
    }
};
</script>

<template>

    <Head title="Documentos" />
    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader 
                title="Gestor de Documentos" 
                subtitle="Administración de archivos compartidos y material educativo." 
                icon="tabler:files" 
                color="indigo"
                :actionsOnBottomOnMobile="false"
            >
                <template #actions>
                    <Buttons 
                        v-if="backLink"
                        label="Volver al listado" 
                        icon="tabler:arrow-left" 
                        size="vuexy" 
                        color="blue" 
                        :href="route('classrooms-collaborator') + backLink" 
                        hideLabelOnMobile 
                    />
                </template>
                <template #bottom>
                    <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pt-1">
                        <PremiumTabs :modelValue="tab" @change="switchTab($event.id)" :tabs="tabsMenu" />

                        <!-- Accesos directos a documentos por nivel y guías de estudio -->
                        <div v-if="$page.props.auth.user.id_rol <= 4 || $page.props.auth.user.id_rol == 10" class="flex flex-wrap items-center gap-2">
                            <Link 
                                :href="route('file-listado', { 'type': 'file_forlevel' })" 
                                class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-xl bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700 hover:border-indigo-300 dark:hover:border-indigo-700 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-indigo-50/50 dark:hover:bg-indigo-950/30 transition-all shadow-sm group"
                            >
                                <div class="p-1 rounded-lg bg-indigo-50 dark:bg-indigo-900/40 text-indigo-500 group-hover:bg-indigo-100 group-hover:text-indigo-600 dark:group-hover:bg-indigo-900/60 dark:group-hover:text-indigo-400 transition-colors shrink-0">
                                    <Icon icon="tabler:files" class="w-4 h-4" />
                                </div>
                                <span>Documentos por Nivel</span>
                                <Icon icon="tabler:arrow-up-right" class="w-3.5 h-3.5 text-slate-400 group-hover:text-indigo-500 dark:group-hover:text-indigo-400 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </Link>

                            <Link 
                                :href="route('file-listado', { 'type': 'file_guideforcourse' })" 
                                class="inline-flex items-center gap-2 px-3 py-1.5 text-xs font-semibold rounded-xl bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 border border-slate-200 dark:border-slate-700 hover:border-emerald-300 dark:hover:border-emerald-700 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-emerald-50/50 dark:hover:bg-emerald-950/30 transition-all shadow-sm group"
                            >
                                <div class="p-1 rounded-lg bg-emerald-50 dark:bg-emerald-900/40 text-emerald-500 group-hover:bg-emerald-100 group-hover:text-emerald-600 dark:group-hover:bg-emerald-900/60 dark:group-hover:text-emerald-400 transition-colors shrink-0">
                                    <Icon icon="tabler:book" class="w-4 h-4" />
                                </div>
                                <span>Guías de Estudio</span>
                                <Icon icon="tabler:arrow-up-right" class="w-3.5 h-3.5 text-slate-400 group-hover:text-emerald-500 dark:group-hover:text-emerald-400 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </Link>
                        </div>
                    </div>
                </template>
            </PremiumPageHeader>
        </template>
        <div v-if="loading" class="fixed container-snap h-full w-full z-50 left-0 top-0 overflow-hidden">
            <div class="flex flex-col items-center justify-center w-full h-full bg-white bg-opacity-80">
                <div class="border-gray-300 h-20 w-20 animate-spin rounded-full border-8 border-t-rose-600 mb-2"></div>
                <p class="text-rose-600">Procesando</p>
            </div>
        </div>

        <!-- Arbol automatico -->
        <div v-if="tab == 0" class="" :class="loading ? 'pointer-events-none' : ''">

            <div class="bg-white overflow-hidden shadow-lg rounded-md border p-4">
                <div class="mb-6 flex justify-between">
                    <!-- Left Ayuda -->
                    <div>
                        <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['documents'] = !showAyuda['documents']">
                            Ayuda
                            <BaseIcon :path="mdiInformationOutline" size="15" />
                        </a>
                    </div>
                    <!-- Right-->

                </div>
                <fieldset v-if="showAyuda['documents']" class="border border-gray-300 p-4 rounded-md mb-6">
                    <legend class="text-lg font-bold px-2">1</legend>
                    <ul>
                        <li>Puede dar click en la opción de lupa azul para ver las lista de documentos</li>
                        <li v-if="isTutor || isMaster">La selección de cursos es según el <b>nombre - aula - nivel</b></li>
                        <li v-else>La selección de cursos es según el <b>nombre - nivel</b></li>
                        <li>Debe establecer seleccionar el curso y el tipo de documento para que se muestre la opción de <b>Elegir archivos</b> a subir</li>
                        <li>Puede Seleccionar o arrastrar varios archivos a la vez</li>
                        <li>Debe establecer un estándar en los nombres de archivos pues se guardarán con el nombre que tenga (sin símbolos)</li>
                        <li>Luego de seleccionar los archivos debe dar cick en el botón <b>Subir Archivos</b></li>
                        <li>Si lo considera puede marcar la opción de Reemplazar archivos con el mismo nombre (Debe estar seguro de realizar esto)</li>
                        <img src="/ayuda/subir_archivos_masivo.png" class="w-auto" />
                        <li>Sólo puede eliminar archivos que usted mismo haya subido</li>
                        <li>La vista previa soporta PDF e imagen. Si desea ver documentos de Office debe descargar una extensión para ello (En Google Chrome es "Edición de Office" <a class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" href="https://chrome.google.com/webstore/detail/office-editing-for-docs-s/gbkeegbaiigmenfmjfclcdgdpimamgkj"> Instalar extensión de Office</a>). <span v-if="isCoord"><b>Atención:</b> Si instala la extensión es más probable que se pueda descargar e imprimir el documento.</span></li>
                        <li>El celular no soporta vista previa.</li>
                    </ul>
                    <br>

                </fieldset>

                <div v-if="countChecked" class="text-sm grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-wrap items-center gap-3 mb-3" :class="loading ? 'pointer-events-none' : ''">

                    <div class="font-semibold sm:col-span-2">
                        {{ countChecked }} filas seleccionadas
                    </div>
                    <div>
                        <select class="w-full" v-model="massaction">
                            <option value="" disabled>Acción masiva</option>
                            <template v-if="confGlobal.value.MAIN_FEATURES_LEVEL >= 2">
                                <option v-for="(sede, index) in apiSedes" :key="index" @click="uploadFiles(sede.ruta, 1, sede.token, index, $page.props.auth.user.user)" :value="'resend' + sede.id">Reenviar a sede {{ sede.label }}</option>
                            </template>
                            <option value="changeCourse">Cambiar curso</option>
                            <option value="changeType">Cambiar tipo</option>
                        </select>
                    </div>
                    <div v-if="massaction == 'changeCourse'">
                        <VueSelect class="select-search-light w-full min-w-[200px]" v-model="id_select1" :options="courses" :get-option-label="(option) => `${option.label} ${option.ref_level ? '- ' + option.ref_level : ''}`" :placeholder="'Seleccionar curso'" />
                    </div>
                    <div v-if="massaction == 'changeType'">
                        <select class="w-full min-w-[150px]" v-model="id_select2">
                            <option value="" selected disabled>Seleccionar tipo</option>
                            <option value="file_guideforcourse">Guía de estudio</option>
                            <option value="file_adviceforcourse">Asesoría</option>
                            <option value="file_motivationforcourse">Motivación</option>
                        </select>
                    </div>
                    <!-- Action -->
                    <div class="sm:col-span-2">
                        <BaseButton color="info" small label="Confirmar" @click="isModalDangerActive = true" />
                        <!--  @click="massAction(massaction)" -->
                        <!-- @click="massAction(checkedRows, massaction)" -->

                        <BaseButton color="danger" small label="Cancelar" @click="cleanVal()" class="ml-3" />
                        <!--  @click="massAction(massaction)" -->
                        <!-- @click="massAction(checkedRows, massaction)" -->
                    </div>
                </div>
                <div class="relative flex flex-col w-full h-full text-gray-700 bg-white mt-4">
                    <div class="content-info text-blue-700 mb-2" v-if="isMaster || isTutor">
                        Como maestro usted puede subir en esta sección recursos de estudio (estos se separan por aulas/secciones)
                    </div>
                    <h3 class="text-xl font-bold">
                        Listado de Documentos ({{ arrayFiles.length }})
                    </h3>
                    <div class="overflow-y-auto min-h-[600px] max-h-[1000px]">
                        <table class="w-full max-h-[1000px] text-left table-auto min-w-max table-collapse">
                            <thead class="top-0 mt-0 sticky bg-white">
                                <tr>
                                    <th>
                                        <div v-if="canWriteAll || isCoord" class="inline-block mr-2">
                                            <label class="checkbox ">
                                                <input v-model="allCheckBox" type="checkbox" @change="changeAllCheckBox()" />
                                                <span class="check" />
                                            </label>
                                        </div>
                                    </th>
                                    <th>#</th>
                                    <th colspan="2" class="p-0 w-[300px]">

                                        <div class="flex justify-between w-full items-center gap-4 p-4 border-b" :class="(isMaster || isTutor) ? 'h-[90px]' : 'h-[70px]'">
                                            <div class="flex justify-center items-center p-4 h-[70px]">
                                                <BaseButton color="info" :icon="mdiMagnify" small class="" @click="listarDocuments()" />
                                            </div>

                                            <div class="w-full ">

                                                <!-- @update:modelValue="handleSelectCourse" ->  -->
                                                <VueSelect class="select-search-light w-full min-w-[150px]" v-model="id_course" :options="courses" @update:modelValue="handleSelectCourse" :get-option-label="(option) => `${option.label} ${option.ref_level ? '- ' + option.ref_level : ''}`" :placeholder="'Curso - Todos'" />
                                                <VueSelect v-if="isMaster || isTutor" class="select-search-light w-full min-w-[150px]" v-model="id_classroom" @update:modelValue="handleSelectClassroom" :options="classrooms" :get-option-label="(option) => `${option.label} - ${option.ref_level}`" :placeholder="'Aula/Sección - Todos'" />
                                            </div>

                                            <div class="w-full">
                                                <select class="w-full min-w-[150px]" v-model="type">
                                                    <option value="" :selected="(isMaster || isTutor ? false : true)" :disabled="(isMaster || isTutor ? true : false)">Documento - Todos</option>
                                                    <template v-if="isMaster || isTutor">
                                                        <option value="file_resource">Recursos del maestro</option>
                                                        <!-- <option value="file_task">Tarea Adjunto</option> -->
                                                        <option value="file_guideforcourse">Guía de estudio</option>
                                                        <option value="file_adviceforcourse">Asesoría</option>
                                                        <option value="file_motivationforcourse">Motivación</option>

                                                    </template>
                                                    <template v-else>
                                                        <option value="file_guideforcourse">Guía de estudio</option>
                                                        <option value="file_adviceforcourse">Asesoría</option>
                                                        <option value="file_motivationforcourse">Motivación</option>
                                                    </template>

                                                    <!-- Asociadas al aula -->
                                                    <!-- <option value="file_resource">Recurso de estudio</option>
                                                        <option value="file_task">Tareas</option>
                                                        <option value="file_taskresp">Tareas Respuestas</option> -->
                                                </select>
                                                <!-- <div class="relative">
                                                        <input class="w-full py-2 px-4 border font-normal border-gray-300 rounded-md focus:outline-none focus:ring-2" type="search" placeholder="Filtrar">
                                                        <button class="absolute inset-y-0 right-0 flex items-center px-2  rounded-r-md btn-outline-light">
                                                            <BaseIcon :path="mdiMagnify" :size="26" class="h-10 w-10" />
                                                        </button>
                                                    </div> -->
                                            </div>
                                        </div>
                                    </th>
                                    <th v-if="canWriteAll || canWrite" class="p-0">
                                        <div v-if="canWriteAll || (canWrite && type == 'file_resource' && id_classroom > 0)" class="flex justify-between items-center p-4 border-b h-[70px]">
                                            <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                Subir Archivos
                                            </p>
                                        </div>
                                    </th>

                                    <th class="p-0">
                                        <div class="flex justify-between items-center p-4 border-b min-h-[70px]">
                                            <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                Creado/Actualizado
                                                <input name="year" class="w-16 ml-3 rounded-md font-normal" :type="(isMaster || isTutor ? 'hidden' : 'text')" v-model="anioSearch">
                                                <!-- :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR" -->
                                            </p>

                                        </div>
                                    </th>
                                    <th class="p-0">
                                        <div class="flex justify-between items-center p-4 border-b min-h-[70px]">
                                            <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                Autor
                                            </p>

                                        </div>
                                    </th>
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center p-4 border-b h-[70px]">
                                                <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                    Actualizado
                                                </p>

                                            </div>
                                        </th>
                                        <th class="p-0">
                                            <div class="flex justify-between items-center p-4 border-b h-[70px]">
                                                <p class="inline-block text-sm font-semibold leading-none text-blue-gray-900 text-gray-700">
                                                    Autor
                                                </p>

                                            </div>
                                        </th> -->
                                    <th class="p-0">
                                        <div class="p-4 flex items-center justify-center border-b min-h-[70px] text-sm font-semibold">
                                            Action
                                        </div>
                                    </th>
                                </tr>
                                <tr v-if="id_course > 0 && ((canWriteAll && type) || (canWrite && type == 'file_resource' && id_classroom > 0))">
                                    <th v-if="canWriteAll || isCoord || isMaster"></th>
                                    <th></th>
                                    <th class="p-0 border-b" colspan="2">
                                        <div class="flex items-center p-2 min-h-[70px] gap-2">
                                            <div class="flex items-center gap-2">
                                                <BaseIcon :path="mdiCloudUploadOutline" :size="26" class="h-10 w-6 text-gray-700 mr-4 inline-block" /> <input id="upload-file" type="file" @change="handleFileSelect" :multiple="allowMultiple" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS" />
                                            </div>
                                            <div>
                                                <div v-html="filepreviewlist" class="font-normal"></div>
                                            </div>
                                        </div>
                                        <!-- <div class="flex flex-row items-center p-4 border-b gap-2 h-[70px]">
                                                
                                                <div class="flex justify-between items-center min-w-[442px] w-full">
                                                    <label for="upload-file" class="flex flex-col items-center justify-center w-full border border-gray-300 border-dashed rounded-md cursor-pointer bg-gray-50  hover:bg-gray-100 h-[38px]">
                                                        <div class="inline-flex items-center justify-center px-4">
                                                            <BaseIcon :path="mdiCloudUploadOutline" :size="26" class="h-10 w-6 text-gray-700 mr-4 inline-block" />
                                                            <span class="font-normal text-xs" v-html="filepreviewlist"></span>
                                                            <p class="text-sm font-normal text-gray-700 ">Para subir un archivo, <span class="font-semibold">arrastrar o click aquí</span></p>
                                                        </div>
                                                        <div class="inline-flex items-center justify-center px-4">
                                                            <input id="upload-file" type="file" @change="handleFileSelect" :multiple="allowMultiple" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS"/>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div> -->
                                    </th>
                                    <th class="p-0 border-b" colspan="5">
                                        <div class="flex items-center py-4 px-2 h-[70px] gap-2">
                                            <!-- <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-01" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-01">
                                                        Carabayllo
                                                    </label>
                                                </div>
                                                <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-02" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-02">
                                                        Tomas Valle
                                                    </label>
                                                </div>
                                                <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-03" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-03">
                                                        Pro
                                                    </label>
                                                </div>
                                                <div role="button" class="flex items-center h-full">
                                                    <input type="checkbox" class="appearance-none hidden peer sr-only" id="id-04" />
                                                    <label class="h-full flex items-center text-xs cursor-pointer font-medium text-slate-600 whitespace-nowrap peer-checked:bg-emerald-500 peer-checked:border-emerald-500 peer-checked:text-white hover:bg-slate-100 focus:bg-slate-100 px-2 py-1 border rounded-md p-0 transition-all ease-in-out" for="id-04">
                                                        San Felipe
                                                    </label>
                                                </div> -->

                                            <!-- Deprecated -->
                                            <!-- <div class="ml-2">
                                                        <BaseButton :color="successUpload ? 'success' : 'light'" :label="loaderUpload ? '' : (apiSedes.length > 0 ? confGlobal.value.UNENS_SEDE_NOMBRE : 'Subir Archivos')" @click="uploadFiles()" :class="loaderUpload ? 'inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2' : ''"></BaseButton>
                                                    
                                                        <template v-if="apiSedes.length > 0" class="ml-2">
                                                            <BaseButton v-for="(sede, index) in apiSedes" :key="index" :color="successUploads[index] ? 'success' : 'light'" :label="loaderUploads[index] ? '' : sede.label" @click="uploadFiles(sede.ruta, 1, sede.token, index)" :class="loaderUploads[index] ? 'inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2' : 'ml-2'"></BaseButton>
                                                        </template>
                                                    </div> -->

                                            <!-- En lugar de input simples botones -->
                                            <span @click="uploadFiles()" class="inline-flex items-center whitespace-nowrap leading-none font-normal text-xs border rounded-md py-1 px-2" :class="successUpload ? 'text-white bg-emerald-500 border-emerald-500' : 'text-gray-700 bg-gray-50'">
                                                {{ loaderUpload ? '' : (apiSedes.length > 0 && canWriteSedes ? confGlobal.value.UNENS_SEDE_NOMBRE : 'Subir Archivos') }}
                                                <span v-if="loaderUpload" class="inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2" />
                                            </span>

                                            <!-- Si existen sedes externas y habilitado el subido de documentos a sedes externas -->
                                            <template v-if="confGlobal.value.SEDE_EXTERNA_UPLOAD_DOCUMENTS === '1' && apiSedes.length > 0 && (canReadSedes || canWriteSedes)">
                                                <span v-for="(sede, index) in apiSedes" :key="index" @click="uploadFiles(sede.ruta, 1, sede.token, index, $page.props.auth.user.user)" class="inline-flex items-center whitespace-nowrap leading-none font-normal text-xs border rounded-md py-1 px-2" :class="successUploads[index] ? 'text-white bg-emerald-500 border-emerald-500' : 'text-gray-700 bg-gray-50'">
                                                    {{ loaderUploads[index] ? '' : sede.label }}
                                                    <span v-if="loaderUploads[index]" class="inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2" />
                                                </span>
                                            </template>

                                            <span class="font-normal text-xs" :class="replace_file ? 'text-red-600' : ''">Reemplazar archivo con el mismo nombre</span>
                                            <input type="checkbox" v-model="replace_file"></input>
                                        </div>
                                    </th>
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">
                                                
                                            </div>
                                        </th>
                                        <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">

                                            </div>
                                        </th> -->
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">
                                                
                                            </div>
                                        </th>
                                        <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">

                                            </div>
                                        </th> -->
                                    <!-- <th class="p-0">
                                            <div class="flex justify-between items-center gap-4 p-4 border-b h-[70px]">

                                            </div>
                                        </th> -->
                                </tr>
                            </thead>
                            <tbody class="overflow-y">
                                <!-- START 1ER CURSO -->
                                <!-- START 1ER CURSO -->
                                <tr v-for="(file, index) in arrayFiles" :key="file.id" :class="selectRows[index + 1] ? '!bg-blue-50' : ''">
                                    <td class="">
                                        <div class="inline-block mr-2">
                                            <label v-if="canWriteAll || isCoord" class="checkbox">
                                                <input v-model="selectRows[index + 1]" type="checkbox" @change="countCheckedSingle()" />
                                                <span class="check" />
                                            </label>
                                        </div>
                                    </td>
                                    <td :title="'ID técnico: ' + file.id">{{ (index + 1) }}</td>
                                    <td class="border-b border-r bg-white px-4" rowspan="">
                                        <div class="flex items-center">
                                            <h2 :title="'ID técnico: ' + file.course_id">{{ file.course_label + ' - ' + file.level_ref }}</h2>
                                        </div>
                                    </td>
                                    <td class="px-2 py-4 border-b max-w-[700px]">
                                        <div class="flex h-full gap-2">
                                            <BaseIcon :path="mdiCircle" :size="8" class="h-4 w-4 mr-2 inline-block" />
                                            <p class="font-medium text-xs text-gray-700"> {{ file.name }}
                                                <span v-if="!type">
                                                    <small v-if="file.type == 'file_guideforcourse'">
                                                        (Guía de estudio)
                                                    </small>
                                                    <small v-else-if="file.type == 'file_adviceforcourse'">
                                                        (Asesoría)
                                                    </small>
                                                    <small v-else-if="file.type == 'file_motivationforcourse'">
                                                        (Motivación)
                                                    </small>
                                                    <small v-else-if="file.type == 'file_resource'">
                                                        (Recurso de estudio)
                                                    </small>
                                                    <small v-else-if="file.type == 'file_task'">
                                                        (Tarea Adjunto)
                                                    </small>
                                                </span>
                                            </p>
                                            <!-- <div class="flex items-center px-2 py-1 font-medium text-xs text-gray-700 rounded-md select-none bg-gray-100 border h-[26px]">
                                                    <p>
                                                        <BaseIcon :path="mdiCircle" :size="8" class="h-4 w-4 mr-2" />{{ file.description }}
                                                    </p>
                                                </div> -->
                                        </div>
                                    </td>
                                    <td v-if="canWrite" class="p-2 border-b align-center">
                                        <!-- A futuro consultar si existe el archivo en cada sede -->
                                        <div v-if="confGlobal.value.MAIN_FEATURES_LEVEL >= 3 && apiSedes.length > 0 && (canReadSedes || canWriteSedes)" class="flex h-full flex-nowrap gap-2 mim-h-[26px]">
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-white bg-emerald-500 border-emerald-500">
                                                    Carabayllo
                                                </span>
                                            </div>
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-gray-700 bg-gray-50">
                                                    Tomas Valle
                                                    <span v-if="1 == 1" class="inline-flex border-red-500 h-3 w-3 animate-spin rounded-full border-2 border-t-white ml-2" />
                                                </span>

                                            </div>
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-gray-700 bg-gray-50">
                                                    Pro
                                                </span>
                                            </div>
                                            <div class="flex items-center ">
                                                <span class="inline-flex items-center whitespace-nowrap leading-none text-xs border rounded-md py-1 px-2 text-gray-700 bg-gray-50">
                                                    San Felipe
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="p-2 border-b align-center">
                                        <div class="flex flex-col gap-2">
                                            {{ formatDateTime(file.updated_at) }}
                                            <small v-if="file.created_at != file.updated_at">
                                                {{ formatDateTime(file.created_at) }}
                                            </small>
                                        </div>
                                    </td>
                                    <td class="p-2 border-b align-center">
                                        <div class="flex flex-col gap-2">
                                            <p>{{ file.nombre_usuario_modif }}</p>
                                        </div>
                                    </td>
                                    <!-- <td class="p-2 border-b align-center">
                                            <div class="flex flex-col gap-2">
                                                {{ formatDateTime(file.updated_at) }}
                                            </div>
                                        </td>
                                        <td class="p-2 border-b align-center">
                                            <div class="flex flex-col gap-2">
                                                <p>{{ file.nombre_usuario_modif }}</p>
                                            </div>
                                        </td> -->
                                    <td class="p-2 border-b align-center">
                                        <div class="flex items-center h-full gap-2">
                                            <!-- <BaseButton v-if="canEdit" color="warning" :icon="mdiPencil" small class="" /> -->


                                            <!-- <BaseButton v-if="canView" color="info"
                                                    :icon="mdiEye" small
                                                    :href="route('pdf-viewer', { 'name': file.name, 'ruta': '/documents/' + file.filepath + '/' + file.filename })"
                                                    target="_blank" /> -->
                                            <BaseButton v-if="canView" color="info" :icon="mdiEye" small @click="showVistaPrevia('/documents/' + file.filepath + '/' + file.filename, (!canWriteAll && type == 'file_resource' ? '' : 'onlyread'))" class="hidden lg:grid" />
                                            <BaseButton v-if="canWriteAll || (!canWriteAll && type == 'file_resource')" color="info" :icon="mdiDownload" small :href="route((file.origin_id2 && file.origin_id2 > 0 ? 'file-download2' : (file.origin_id && file.origin_id > 0 ? 'file-download' : 'file-download')), { 'srctype': file.type, 'srcid': (file.src_object_id ? file.src_object_id : 0), 'filename': file.filename, 'srcid2': (file.origin_id2 ? file.origin_id2 : 0) })" target="_blank" @click="" />
                                            <BaseButton v-if="canDelete || file.user_modif == $page.props.auth.user.id" color="danger" :icon="mdiTrashCan" small class="" @click="initModal(file.id, 'eliminar')" />
                                        </div>
                                    </td>
                                </tr>

                                <!-- END 1ER CURSO -->
                                <!-- END 1ER CURSO -->

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- Documentos libres -->
        <div v-if="tab == 1" class="" :class="loading ? 'pointer-events-none' : ''">

            <div class="flex justify-between items-center mb-4">
                <div class="flex items-center lg:flex-row flex-col gap-2">
                    <div class="flex items-center flex-wrap gap-y-1">
                        <template v-for="(crumb, cIdx) in freeBreadcrumbs" :key="cIdx">
                            <div class="flex items-center">
                                <button @click="fetchFreeFolder(crumb.id)" class="text-xs hover:text-blue-600 font-semibold focus:outline-none transition-colors">
                                    {{ crumb.name }}
                                </button>
                                <BaseIcon v-if="cIdx < freeBreadcrumbs.length - 1" :path="mdiChevronRight" :size="20" class="mx-1 text-gray-400 w-4 h-4" />
                            </div>
                        </template>
                    </div>
                    <div class="flex items-center w-full lg:w-auto">
                        <h3 class="text-lg font-bold text-gray-800 ml-0 lg:ml-2 mt-1 lg:mt-0">
                            {{ freeBreadcrumbs.length > 1 ? freeBreadcrumbs[freeBreadcrumbs.length - 1].name : 'Documentos Libres' }}
                        </h3>
                    </div>
                </div>
                <div class="flex gap-2">
                    <BaseButton color="success" :icon="mdiPlusCircle" small label="Crear Carpeta" @click="openFolderModal" />
                    <BaseButton color="info" :icon="mdiArrowUpBold" small label="Subir Archivo" @click="openFileUploadModal" />
                </div>
            </div>

            <div class="bg-white shadow-lg rounded-md border p-4 h-[calc(100vh-265px)] relative">
                <div class="h-full overflow-y-auto overflow-x-auto">
                    <table class="w-full table-collapse">
                        <thead class="top-0 mt-0 sticky bg-white font-semibold z-10">
                            <tr class="">
                                <th class="p-0 w-12 text-center">
                                    <div class="border-b p-2">
                                        Tipo
                                    </div>
                                </th>
                                <th class="p-0">
                                    <div class="border-b p-2 whitespace-nowrap text-left">
                                        Nombre
                                    </div>
                                </th>
                                <th class="p-0 w-44">
                                    <div class="border-b p-2 whitespace-nowrap text-left">
                                        Modificado
                                    </div>
                                </th>
                                <th class="p-0 w-44">
                                    <div class="border-b p-2 whitespace-nowrap text-left">
                                        Usuario
                                    </div>
                                </th>
                                <th class="p-0 w-36 text-right">
                                    <div class="border-b p-2 text-right">
                                        Acciones
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="overflow-y">
                            <!-- FOLDERS -->
                            <tr v-for="folder in freeFolders" :key="'dir-' + folder.id" class="hover:bg-gray-50 border-b transition-colors">
                                <td class="px-2 py-4 text-center">
                                    <BaseIcon :path="mdiFolder" :size="24" class="text-amber-400 w-6 h-6 mx-auto" />
                                </td>
                                <td class="px-2 py-4">
                                    <div class="flex items-center gap-2">
                                        <button @click="fetchFreeFolder(folder.id)" class="text-left font-medium text-blue-600 hover:text-blue-800 hover:underline">
                                            {{ folder.name }}
                                        </button>
                                        <span class="inline-flex items-center text-xs" :title="folder.fk_user_owner ? 'Privado' : 'Público'">
                                            <span v-if="!folder.fk_user_owner" class="px-1.5 py-0.5 rounded text-[10px] bg-green-100 text-green-800 flex items-center gap-0.5">
                                                <span class="w-1.5 h-1.5 rounded-full bg-green-500"></span> Público
                                            </span>
                                            <span v-else class="px-1.5 py-0.5 rounded text-[10px] bg-gray-100 text-gray-800 flex items-center gap-0.5">
                                                <span class="w-1.5 h-1.5 rounded-full bg-gray-400"></span> Privado
                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td class="px-2 py-4 text-sm text-gray-500 whitespace-nowrap">
                                    {{ formatDateTime(folder.updated_at) }}
                                </td>
                                <td class="px-2 py-4 text-sm text-gray-500">
                                    {{ folder.user_modif ? folder.user_modif.name : (folder.user_creat ? folder.user_creat.name : 'Sistema') }}
                                </td>
                                <td class="px-2 py-4 text-right whitespace-nowrap">
                                    <div class="flex items-center justify-end gap-1">
                                        <BaseButton color="warning" :icon="mdiPencil" small @click="openRenameFolderModal(folder)" title="Renombrar" />
                                        <BaseButton color="danger" :icon="mdiTrashCan" small @click="deleteFreeFolder(folder)" title="Eliminar" />
                                    </div>
                                </td>
                            </tr>

                            <!-- FILES -->
                            <tr v-for="file in freeFiles" :key="'file-' + file.id" class="hover:bg-gray-50 border-b transition-colors">
                                <td class="px-2 py-4 text-center">
                                    <BaseIcon :path="getFileIcon(file.extension)" :size="24" :class="[getFileIconColor(file.extension), 'w-6 h-6 mx-auto']" />
                                </td>
                                <td class="px-2 py-4">
                                    <div class="flex flex-col">
                                        <div class="flex items-center gap-2">
                                            <span class="font-medium text-gray-700">{{ file.name }}</span>
                                            <span class="inline-flex items-center text-xs" :title="file.fk_user_owner ? 'Privado' : 'Público'">
                                                <span v-if="!file.fk_user_owner" class="px-1.5 py-0.5 rounded text-[10px] bg-green-100 text-green-800 flex items-center gap-0.5">
                                                    <span class="w-1.5 h-1.5 rounded-full bg-green-500"></span> Público
                                                </span>
                                                <span v-else class="px-1.5 py-0.5 rounded text-[10px] bg-gray-100 text-gray-800 flex items-center gap-0.5">
                                                    <span class="w-1.5 h-1.5 rounded-full bg-gray-400"></span> Privado
                                                </span>
                                            </span>
                                        </div>
                                        <span class="text-xs text-gray-400 mt-0.5">{{ formatBytes(file.size) }}</span>
                                    </div>
                                </td>
                                <td class="px-2 py-4 text-sm text-gray-500 whitespace-nowrap">
                                    {{ formatDateTime(file.updated_at) }}
                                </td>
                                <td class="px-2 py-4 text-sm text-gray-500">
                                    {{ file.user_modif ? file.user_modif.name : (file.user_creat ? file.user_creat.name : 'Sistema') }}
                                </td>
                                <td class="px-2 py-4 text-right whitespace-nowrap">
                                    <div class="flex items-center justify-end gap-1">
                                        <BaseButton color="info" :icon="mdiEye" small @click="showVistaPrevia('/free-files/' + file.id + '/view')" title="Previsualizar" />
                                        <a :href="'/free-files/' + file.id + '/download'" target="_blank" class="inline-flex justify-center items-center p-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-xs transition-colors" title="Descargar" style="height: 28px; width: 28px;">
                                            <BaseIcon :path="mdiDownload" :size="16" class="w-4 h-4" />
                                        </a>
                                        <BaseButton color="warning" :icon="mdiPencil" small @click="openRenameFileModal(file)" title="Renombrar" />
                                        <BaseButton color="danger" :icon="mdiTrashCan" small @click="deleteFreeFile(file)" title="Eliminar" />
                                    </div>
                                </td>
                            </tr>

                            <!-- EMPTY LAYOUT -->
                            <tr v-if="freeFolders.length === 0 && freeFiles.length === 0">
                                <td colspan="5" class="py-16 text-center text-gray-400">
                                    <div class="flex flex-col items-center justify-center">
                                        <BaseIcon :path="mdiCloudUploadOutline" :size="48" class="text-gray-300 mb-2 w-12 h-12" />
                                        <p class="text-sm font-medium">Esta carpeta está vacía</p>
                                        <p class="text-xs text-gray-400 mt-1">Crea una subcarpeta o sube un archivo nuevo para empezar.</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>

        <!-- Modales -->
        <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')">
            <!-- <v-icon>{{ selectedEvent.icon }}</v-icon> -->
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <div v-html="selectedEvent.contentFull" />

            <div v-if="canUpdate">
                <BaseButton color="warning" :icon="mdiPencil" small label=" Modificar evento" class="" @click="initModal(selectedEvent.id, 'update', selectedEvent)" />
            </div>

            <div v-if="canDelete">
                <BaseButton color="danger" :icon="mdiTrashCan" small label=" Eliminar evento" class="" @click="initModal(selectedEvent.id, 'delete')" />
            </div>
            <!-- <strong>Info.:</strong>
                <ul>
                    <li>Inicio: {{ selectedEvent.start && selectedEvent.start.formatTime() }}</li>
                    <li>Fin: {{ selectedEvent.end && selectedEvent.end.formatTime() }}</li>
                </ul> -->
        </CardBoxModal>
        <CardBoxModal v-model="isModalActive" hasCancel :title="titleModal" @confirm="isConfirm" @cancel="isCancel">
            <div class="p-4 md:p-5 space-y-4 overflow-y-auto h-[450px]">
                <p class="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                    Puede crear actividades/eventos en su calendario.
                </p>
                <span v-if="errorEvent" v-text="errorEvent" class="text-red-500"></span>
                <div class="col-span-1">
                    <label>Tipo</label>
                    <select v-model="formEvent.type_source">
                        <option value="user_private" selected>Privado</option>
                        <option value="temario" selected>Temario</option>
                    </select>
                </div>
                <div v-if="formEvent.type_source == 'temario'" class="relative">
                    <label class="block font-bold mb-2 ml-2">Curso</label>
                    <select v-model="formEvent.id_source" class="inline-block ml-2 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm">
                        <option value="0" selected>Escoge un curso</option>
                        <option v-for="option in courses" :value="option.id">{{ option.label_course + ' - ' + option.label_classroom }}</option>
                    </select>
                </div>
                <div class="col-span-1">
                    <label>{{ (formEvent.type_source == 'temario' ? 'Tema' : 'Título') }}</label>
                    <input type="text" v-model="formEvent.title" class="w-full">
                </div>
                <div class="flex justify-between items-center gap-2 w-full">
                    <div class="flex flex-col lg:flex-row gap-2">
                        <div class="inline-block">
                            Inicio: <input type="datetime-local" v-model="formEvent.start">
                        </div>
                        <div class="inline-block">
                            Fin: <input type="datetime-local" v-model="formEvent.end">
                        </div>
                    </div>

                </div>
                <div class="col-span-1">
                    <label>{{ (formEvent.type_source == 'temario' ? 'Contenidos básicos' : 'Descripción (Opcional)') }}</label>
                    <textarea value="" class="w-full" v-model="formEvent.contentFull"></textarea>
                </div>

            </div>
        </CardBoxModal>
        <CardBoxModal v-model="isModalDangerActive" title="Por Confirmar" button="danger" hasCancel @confirm="isConfirm" @cancel="isCancel">
            <p>Está seguro de <b>{{ titleModal }}</b></p>
            <p>este registro?</p>
        </CardBoxModal>

        <!-- Vista previa guia de estudio u otro -->
        <CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel>
            <!-- tien el botón de cancelar superior-->
            <div class="flex justify-center w-full" :class="srcParamOnlyRead ? 'view-wrapper' : ''">
                <!-- src="modalFullSrc + (isCoord ? '#toolbar=0' : '')" class="min-h <-- Mejor mostrar siempre --> <!-- v-if="modalFullSrc && (['xlsx', 'pptx', 'docx'].includes(modalFullSrc.split('.').pop()))" -->
                <!-- :class="(modalFullSrc && (['pdf', 'xlsx', 'pptx', 'docx'].includes(modalFullSrc.split('.').pop())) ? 'w-full' : 'w-auto ')" -->
                <embed :src="modalFullSrc + srcParamOnlyRead" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full" :oncontextmenu="(isMaster || isCoord ? false : true)" :class="(modalFullSrc && (['pdf', 'xlsx', 'pptx', 'docx'].includes(modalFullSrc.split('.').pop())) ? 'w-full' : 'w-auto ')">
                <div v-if="srcParamOnlyRead" class="view-embed-cover"></div>
            </div>
        </CardBoxModal>

        <!-- Modales de Documentos Libres -->
        <CardBoxModal v-model="isFolderModalActive" hasCancel title="Crear Nueva Carpeta" @confirm="createFreeFolder" @cancel="isFolderModalActive = false">
            <div class="p-4 space-y-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Nombre de la carpeta</label>
                    <input type="text" v-model="freeFolderForm.name" class="w-full border border-gray-300 focus:border-blue-500 focus:ring-blue-500 rounded-md shadow-sm p-2" placeholder="Ej. Carpeta de Trabajo">
                </div>
                <div class="flex items-center">
                    <input id="folder-public-checkbox" type="checkbox" v-model="freeFolderForm.isPublic" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                    <label for="folder-public-checkbox" class="ml-2 block text-sm text-gray-900 font-medium">
                        Hacer esta carpeta pública
                    </label>
                </div>
                <p class="text-xs text-gray-500">Las carpetas públicas son visibles por todos los usuarios. Las privadas solo por ti.</p>
            </div>
        </CardBoxModal>

        <CardBoxModal v-model="isRenameFolderModalActive" hasCancel title="Renombrar Carpeta" @confirm="submitRenameFolder" @cancel="isRenameFolderModalActive = false">
            <div class="p-4 space-y-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Nuevo nombre de la carpeta</label>
                    <input type="text" v-model="freeFolderForm.name" class="w-full border border-gray-300 focus:border-blue-500 focus:ring-blue-500 rounded-md shadow-sm p-2">
                </div>
            </div>
        </CardBoxModal>

        <CardBoxModal v-model="isRenameFileModalActive" hasCancel title="Renombrar Archivo" @confirm="submitRenameFile" @cancel="isRenameFileModalActive = false">
            <div class="p-4 space-y-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Nuevo nombre del archivo</label>
                    <input type="text" v-model="freeFileForm.name" class="w-full border border-gray-300 focus:border-blue-500 focus:ring-blue-500 rounded-md shadow-sm p-2">
                </div>
            </div>
        </CardBoxModal>

        <CardBoxModal v-model="isFileUploadModalActive" hasCancel title="Subir Archivo" @confirm="uploadFreeFiles" @cancel="isFileUploadModalActive = false">
            <div class="p-4 space-y-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Seleccionar archivo(s)</label>
                    <input type="file" multiple @change="handleFreeFileSelect" class="w-full border border-gray-300 p-2 rounded-md shadow-sm text-sm">
                </div>
                <div v-if="freeFilePreviewList" class="p-2 bg-gray-50 rounded border max-h-32 overflow-y-auto">
                    <p class="text-xs font-semibold text-gray-600 mb-1">Archivos seleccionados:</p>
                    <div v-html="freeFilePreviewList"></div>
                </div>
                <div class="flex items-center">
                    <input id="file-public-checkbox" type="checkbox" v-model="uploadFreeFileIsPublic" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                    <label for="file-public-checkbox" class="ml-2 block text-sm text-gray-900 font-medium">
                        Hacer estos archivos públicos
                    </label>
                </div>
                <p class="text-xs text-gray-500">Los archivos públicos pueden ser descargados y visualizados por todos los usuarios. Los privados solo por ti.</p>
            </div>
        </CardBoxModal>
    </BreezeAuthenticatedLayout>
</template>
<style scope></style>
